<script setup lang="tsx">
import { onMounted, ref } from 'vue'
import Multiselect from 'vue-multiselect'
import type { Response, Asset } from '@/models/api-generated'
import http from '@/services/http'
import type { DefaultFilter } from '@/models/filters-generated'
import { useI18n } from 'vue-i18n'
import { viewing } from '@/services/utils'

const props = defineProps<{
	excludeIds: number[]
}>()

const model = defineModel<Asset>()

const { t } = useI18n()

const isLoading = ref(false)
const options = ref<Asset[]>([])

const search = async (q: string = '') => {
	isLoading.value = true

	const flt: DefaultFilter = {
		q,
		excludeIds: props.excludeIds,
		instanceId: viewing.value,
		type: '',
	}

	const { data } = await http.get<Response<Asset[]>>('api/asset/autocomplete', {
		params: flt,
	})

	options.value = data.data ?? []

	isLoading.value = false
}

onMounted(search)
</script>

<template>
	<Multiselect
		:multiple="false"
		:show-labels="false"
		:options="options"
		:internal-search="false"
		:preserve-search="true"
		:show-no-results="false"
		:loading="isLoading"
		v-model="model"
		label="name"
		track-by="id"
		@search-change="search"
		:placeholder="t('misc.search')"
		:taggable="false"
	>
		<template #option="{ option }">
			<div class="d-flex justify-content-between align-items-center w-100">
				<span v-one-tooltip="option.description">{{ option.name }}</span>
			</div>
		</template>
	</Multiselect>
</template>
